export default "__VITE_ASSET__DshSQWIn__"